<template>
    <div :class="preCls + 'content-box'">
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.nickname"
                    placeholder="请输入姓名"
                    style="margin-left: 10px"
                    @search="search"
                >
                </table-searcher>
            </template>
            <Button
                v-if="$can('add')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
            >
                新增
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:enabled="{ row }">
                <i-switch
                    v-model="row.enabled"
                    size="large"
                    :true-value="1"
                    :false-value="0"
                    :readonly="!$can('update')"
                    @on-change="changeStatus(row)"
                >
                    <span slot="open">启用</span>
                    <span slot="close">禁用</span>
                </i-switch>
            </template>
            <template v-slot:action="{ row }">
                <Button
                    v-if="$can('view')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickView(row)"
                >
                    详情
                </Button>
                <Button
                    v-if="$can('update')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickUpdate(row)"
                >
                    修改
                </Button>
                <PoptipButton
                    v-if="$can('update')"
                    text="重置密码"
                    transfer
                    placement="top-end"
                    type="default"
                    title="重置后密码为123456, 确认重置吗？"
                    :ok="() => rowConfirmReset(row)"
                ></PoptipButton>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.page"
            @change="fetch"
        >
        </table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="showUserForm"
            :maskClosable="maskClosable"
            :title="actionTitle + '用户'"
            :height="600"
            :width="800"
            :buttons.sync="userFormBtns"
            @close-by-confirm="fetch"
        >
            <user-form
                v-if="showUserForm"
                :id="userId"
                :actionType="actionType"
            />
        </smart-modal>
    </div>
</template>
<script>
import { mapCell } from '_c/grid/renderCell'
import { userList, userEnabled, resetPwd } from '@/api/sys-user'
import UserForm from './form'
import Enum from '_u/enum'

const PAGE_SIZE = 20
const fetchData = function () {
    return Promise.all([
        userList({
            page: 1,
            pageSize: PAGE_SIZE,
        }),
    ])
}

export default {
    components: {
        UserForm,
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            actionType: '', // 1 新增; 2 查看; 3 修改;
            filter: {
                page: 1,
                pageSize: PAGE_SIZE,
                nickname: '',
            },
            page: {
                total: 0,
                list: [],
            },
            dict: { actionType: this.$dict.NULL },
            modal: {},
            curId: '',
            maskClosable: false,
            showUserForm: false,
            userFormBtns: [],
            userId: '',
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 80,
                },
                {
                    key: 'nickname',
                    title: '姓名',
                    align: 'left',
                    minWidth: 100,
                },
                {
                    key: 'phone',
                    title: '手机',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'roleName',
                    title: '岗位',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'enabled',
                    title: '禁用',
                    align: 'center',
                    minWidth: 120,
                    slot: 'enabled',
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    slot: 'action',
                    minWidth: 180,
                },
            ]
        },

        actionTitle() {
            return this.dict.actionType.val(this.actionType)
        },
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    created() {
        this.fetch()
    },

    methods: {
        changeStatus(row) {
            this.loading = true

            userEnabled(row.id)
                .then(() => {
                    this.$Message.success(this.$t('tips.update.success'))
                })
                .finally(() => (this.loading = false))
        },
        fetch() {
            this.loading = true

            Promise.all([
                userList(this.filter),
                this.$dict.get(['action_type']),
            ])
                .then((args) => {
                    var [page, group] = args

                    Object.assign(this.dict, group)

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.page = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },
        fillData(args) {
            var [page] = args
            this.setPageData(page.data)
        },
        onClickAdd() {
            this.actionType = '1'
            this.userId = ''
            this.showUserForm = true
        },

        rowClickView(row) {
            this.actionType = '2'
            this.userId = row.id
            this.showUserForm = true
        },

        rowClickUpdate(row) {
            this.actionType = '3'
            this.userId = row.id
            this.showUserForm = true
        },

        rowConfirmReset(row) {
            resetPwd(row.id)
                .then(() => {
                    this.$Message.success(this.$t('tips.update.success'))
                })
                .finally(() => this.fetch())
        },
    },
}
</script>
<style lang="less" scoped></style>
